<template>
  <div>
    <common-table
      :limitHeight="true"
      :url="url"
      :table-columns="tableColumns"
      :form-fields="formFields"
      :permission="permission"
      :searchs="searchs"
      :operate="operate"
      pageName="SmartRoiRuleLogs"
      ref="table"
    />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "SmartRoiRuleLogs",
  components: { CommonTable },
  data() {
    return {
      autoUpdate: true,
      operate: [],
      searchs: [
        {
          name: "ruleId",
          placeholder: "规则Id",
          type: "input",
        },
        {
          name: "adId",
          placeholder: "任务Id",
          type: "input",
        },
        {
          name: "agentId",
          placeholder: "代理",
          type: "select",
          selectUrl: "/agent/getAll",
          selectData: [],
        },
        {
          name: "taskStatus",
          placeholder: "任务状态",
          type: "select",
          selectValue: [
            { key: "CREATED", value: "已创建" },
            { key: "ENQUEUED", value: "已入队" },
            { key: "RUNNING", value: "执行中" },
            { key: "SUCCESS", value: "执行成功" },
            { key: "FAILED", value: "执行失败" },
            { key: "SKIPPED", value: "已跳过" },
            { key: "RETRYING", value: "重试中" },
            { key: "DEAD_LETTER", value: "死信" },
          ],
        },
        {
          name: "taskType",
          placeholder: "任务类型",
          type: "select",
          selectValue: [
            { key: "0", value: "全域亏损关停" },
            { key: "1", value: "智能调控ROI" },
            { key: "2", value: "余额预警" },
            { key: "3", value: "预算提醒" },
            { key: "4", value: "智能重建" },
          ],
        },
      ],
      permission: {
        add: "smartRoiRuleLogs:add",
        update: "smartRoiRuleLogs:update",
        delete: "smartRoiRuleLogs:delete",
        deleteBatch: "smartRoiRuleLogs:deleteBatch",
      },
      url: {
        get: "/smartRoiRuleLogs/typeList",
        add: "/smartRoiRuleLogs/add",
        update: "/smartRoiRuleLogs/update",
        delete: "/smartRoiRuleLogs/delete/",
        delete_batch: "/smartRoiRuleLogs/deleteBatch",
      },
      tableColumns: [
        {
          field: "id",
          label: "ID",
          show: false,
          width: "75",
          detail: true,
        },
        {
          field: "agentId",
          label: "代理",
          selectUrl: "/agent/getAll",
          selectData: [],
          show: {
            type: "select",
          },
          width: "100",
        },
        {
          field: "ruleId",
          label: "规则ID",
          show: true,
          detail: true,
          width: "75",
        },
        {
          field: "ruleName",
          label: "规则名称",
          show: true,
          detail: true,
          width: "",
        },
        {
          field: "executeResult",
          label: "执行结果",
          show: true,
          detail: true,
          width: "300",
        },
        {
          field: "adId",
          label: "计划ID",
          show: true,
          detail: true,
          width: "",
        },
        {
          field: "remark",
          label: "备注",
          show: true,
          detail: true,
          width: "",
        },
        {
          field: "createTime",
          label: "创建时间",
          show: true,
          detail: true,
          width: "",
        },
        {
          field: "executeData",
          label: "执行时数据",
          show: true,
          detail: true,
          executeData: true,
          width: "",
        },
        {
          field: "totalRoiTarget",
          label: "整体ROI目标",
          show: true,
          detail: true,
          totalRoiTarget: true,
          width: "",
        },
      ],
      formFields: {
        addTitle: "ROI规则日志",
        updateTitle: "ROI规则日志",
        model: [
          {
            field: "ruleId",
            label: "规则Id",
            type: "input",
            placeholder: "规则Id",
            rules: [{ required: true, message: "请输入规则Id", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "adId",
            label: "任务Id",
            type: "input",
            placeholder: "任务Id",
            rules: [{ required: true, message: "请输入任务Id", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "agentId",
            label: "代理",
            type: "select",
            placeholder: "请选择代理",
            selectUrl: "/agent/getAll",
            selectData: [],
            rules: [{ required: true, message: "请选择代理", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "executeResult",
            label: "执行结果",
            type: "textarea",
            placeholder: "请输入执行结果",
            rules: [],
            add: true,
            update: true,
          },
          {
            field: "remark",
            label: "备注",
            type: "input",
            placeholder: "请输入备注",
            rules: [],
            add: true,
            update: true,
          },
        ],
      },
    };
  },
};
</script>

<style scoped></style>
